import { Controller } from "@hotwired/stimulus"

// The cadastral moment (docs/connexio-de-llocs.md): fetches the Catastro
// lookup as JSON once the screen is on, then reveals one of three states —
// a single proposal to confirm, a short list to pick from, or a quiet
// nothing-found that only leaves the way out to the portada.
export default class extends Controller {
  static targets = [
    "loading",
    "proposal",
    "description",
    "reference",
    "choices",
    "choiceList",
    "empty",
    "referenceField",
    "commitButton"
  ]

  static values = { url: String }

  connect() {
    this.lookup()
  }

  async lookup() {
    try {
      const response = await fetch(this.urlValue, { headers: { Accept: "application/json" } })
      if (!response.ok) throw new Error("lookup failed")

      this.render(await response.json())
    } catch {
      this.show(this.emptyTarget)
    }
  }

  render({ outcome, candidates }) {
    if (outcome === "clear") {
      const candidate = candidates[0]
      this.referenceFieldTarget.value = candidate.reference
      this.referenceTarget.textContent = candidate.reference
      this.descriptionTarget.textContent = candidate.description || ""
      this.show(this.proposalTarget)
    } else if (outcome === "ambiguous") {
      this.renderChoices(candidates)
      this.show(this.choicesTarget)
    } else {
      this.show(this.emptyTarget)
    }
  }

  renderChoices(candidates) {
    this.choiceListTarget.innerHTML = candidates.map((candidate, index) => `
      <label class="flex min-h-11 cursor-pointer items-start gap-3 border-b border-border px-4 py-3 last:border-b-0">
        <input type="radio" name="cadastre_choice" value="${this.escapeHtml(candidate.reference)}"
               data-action="cadastre#choose" class="mt-1 accent-current" ${index === 0 ? "checked" : ""}>
        <span>
          <span class="block font-mono text-sm">${this.escapeHtml(candidate.reference)}</span>
          <span class="mt-0.5 block text-sm text-muted-foreground">${this.escapeHtml(candidate.description || "")}</span>
        </span>
      </label>
    `).join("")

    this.referenceFieldTarget.value = candidates[0]?.reference || ""
  }

  choose(event) {
    this.referenceFieldTarget.value = event.currentTarget.value
  }

  show(section) {
    for (const target of [this.loadingTarget, this.proposalTarget, this.choicesTarget, this.emptyTarget]) {
      target.classList.toggle("hidden", target !== section)
    }
    // Two instances of the same commit action (mobile header, desktop form
    // footer); their breakpoint visibility lives on their containers
    const committable = section === this.proposalTarget || section === this.choicesTarget
    for (const button of this.commitButtonTargets) {
      button.classList.toggle("hidden", !committable)
    }
  }

  escapeHtml(text) {
    const element = document.createElement("div")
    element.textContent = text
    return element.innerHTML
  }
}
